import { CustomTextField } from "styles/jss/Inputs.styles";
import { useRef } from "react";
import { useRouter } from "next/router";
import { InputAdornment, useMediaQuery } from "@mui/material";
import SearchIcon from "../IconsSvg/SearchIcon";
import { useTranslation } from "next-i18next";

export default function SearchInput() {
  const { t } = useTranslation(["nav"]);
  const { locale, push } = useRouter();
  const inputRef = useRef(null);
  const handle_search = async evt => {
    evt.preventDefault();
    push({
      pathname: "/",
      query: { search: inputRef.current.value },
      locale,
    });
  };
  const matches = useMediaQuery("(max-width:1100px)");
  return (
    <form onSubmit={handle_search}>
      <CustomTextField
        autoFocus={true}
        type="text"
        fullWidth
        variant="outlined"
        margin="dense"
        inputRef={inputRef}
        {...(matches
          ? {
              autoFocus: false,
              placeholder: t("search.title"),
              InputProps: {
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              },
            }
          : {})}
      />
    </form>
  );
}
